import { createContext, useContext, useState } from "react";
import { createAnalytics  } from "./tracking";
import { AnalyticsInterface } from "./types";

interface IAnalyticsContext {
  trackEvent: Function,
  identify: Function,
  setUserId: Function,
  bootEngagement: Function,
  setTheme: Function,
  setLanguage: Function
}

export const AnalyticsContext = createContext<IAnalyticsContext | null>(null);

type AnalyticsProps = {
  children?: any,
  apiKey?: string,
  sessionReplay?: boolean,
  sampleRate?: number,
  userId?: string,
  userInfo?: Record<string, any>
};

export const AnalyticsProvider = ({
  children = <div/>,
  apiKey = "",
  sessionReplay = false,
  sampleRate = .005,
  userId
}: AnalyticsProps) => {

  const [amp] = useState<AnalyticsInterface>(() => {
    const analytics = createAnalytics(apiKey, sessionReplay, sampleRate, userId)
    return analytics;
  });

  if (!amp) return null;

  return (
    <AnalyticsContext.Provider value={{
      trackEvent: (event: string, data?: Object) => amp.track(event, data),
      identify: (user: Record<string, any>) => amp.identify(user),
      setUserId: (userId: string) => amp.setUserId(userId),
      bootEngagement: () => amp.bootEngagement(),
      setTheme: (theme: string) => amp.setTheme(theme),
      setLanguage: (lang: string) => amp.setLanguage(lang)
    }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = (): IAnalyticsContext => {
  const context = useContext(AnalyticsContext);
  if (context === null)
    throw new Error('useAnalytics must be used within a <AnalyticsProvider>');
  return context;
};
